import React from 'react';
import '../index.scss';
import classNames from 'classnames';

const errorInfo = (props: {isEn:boolean; className?: string;})=> {
  const { isEn, className} = props || {};
  return (
    <div className={classNames(className,'db-error-wrap', )} >
      <span className="db-error">
        {isEn ? 'This function is not open yet. Please look forward to it.' : '该功能尚未开放。 敬请期待。'}
      </span>
    </div>
  );
};

export default errorInfo;